import client from '../httpClient';

const customerUpdateShareApi = (customerId, param) => {
  return client.put(`/customers/share/${String(customerId)}`, JSON.stringify(param));
};

export default customerUpdateShareApi;
